import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// Reactstrap components
import { Button, Card, CardHeader, CardBody, CardFooter, FormGroup, Input, Row, Col, Container, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

// style
import "assets/css/loading.css";

// services
import { removeAllCookies } from "services/cookies.js";
import { api_GET, api_POST } from "services/api_service.js";
import { showMessage, showQuestion } from "services/message.js";
import { CancelarRequerimentoByProtocolo } from "services/requerimento_service.js";
import { getSetupAmibiente } from "services/setupGeral_service.js";

// views
import FichaTransportador from "../Shared/Transportador/FichaTransportador";
import FichaGerador from "../Shared/Gerador/FichaGerador";
import FichaDestino from "../Shared/Destino/FichaDestino";
import CardWhatsapp from "./components/CardWhatsapp";

export default function MeuCadastro({ history }) {
    const { register, errors, setError, clearErrors, getValues } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    const [setup, set_setup] = React.useState(null);
    const [protocolo, set_protocolo] = useState(null);
    const [meuCadastro, set_MeuCadastro] = useState();
    const [itemMeuCadastro, set_itemMeuCadastro] = useState(null);

    const loadSetup = () => {
        getSetupAmibiente(function (retorno) {
            if (retorno) {
                set_setup(retorno.data);
            }
        });
    }

    useEffect(() => {
        loadSetup();
        removeAllCookies();

        const authenticationData = JSON.parse(localStorage.getItem("AutenticacaoUsuario"));
        if (authenticationData) {
            const _dataAcesso = new Date(authenticationData.dataAcesso || 0);
            const dataAtual = new Date();
            const diferencaComDataAtual = dataAtual - _dataAcesso;
            const validar24Horas = diferencaComDataAtual < 24 * 60 * 60 * 1000;
            if (validar24Horas) {
                loadProtocolo(authenticationData);
            } else {
                localStorage.removeItem("AutenticacaoUsuario");
            }
        }
    }, []);

    const handleClickConsultar = () => {
        setshowLoading(true);
        let data = getValues();

        if (data.cpf_cnpj == "") {
            showMessage("Atenção", "Informe o CNPJ/CPF para acessar MEU CADASTRO!", 'warning', null);
            setshowLoading(false);
            return;
        }

        api_GET('protocolo/MeuCadastro/' + data.cpf_cnpj).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_MeuCadastro(result.data);
            }
        });
    }

    const handleCard = (item, key) => {
        return (
            <Col key={key} lg="4" md="6" sm="6">
                <Card className="card-stats card-box">
                    <CardHeader className="text-center titulo-card">
                        {item.categoria_Descricao == "RSS" ? item.segmento.replace("Grande", "") : item.segmento}
                        <br />
                        <label>{item.categoria_Descricao}</label>
                        <div className="text-left">
                            <small>Responsável: {item.nomeResponsavel}</small><br />
                            <small>Endereço: {item.endereco}</small>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md="12" xs="12" >
                                <div className="icon-lg text-center icon-warning">
                                    <i class={item.classeIcone + " " + item.CorIcone}></i>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter className="text-center">
                        <hr />
                        {item.mensagemBloqueioNovoCadastro != null &&
                            <div>
                                <Button color="gray" onClick={() => showMessage("Atenção", item.mensagemBloqueioNovoCadastro, 'warning', null)}>Atenção </Button>
                                <br />
                                <br />
                                <Button color="success" className="btn-mobile" onClick={() => { handleRecuperarRequerimento(item); }} style={{ width: "100%" }}>Recuperar Requerimento</Button>
                                <br />
                                <br />
                                <Button color="danger" className="btn-mobile" onClick={() => { handleCancelarRequerimento(item); }} style={{ width: "100%" }}>Cancelar Requerimento</Button>
                            </div>
                        }
                        {item.mensagemBloqueioNovoCadastro == null &&
                            <Button color="success" onClick={() => openModal(item)}>Acessar </Button>
                        }
                    </CardFooter>
                </Card>
            </Col>
        );
    }

    const handleCancelarRequerimento = (item) => {
        showQuestion('Atenção', 'Deseja cancelar este requerimento?', 'question', function (result) {
            if (result) {
                setshowLoading(true);
                CancelarRequerimentoByProtocolo(item.protocolo_Id, function (result) {
                    setshowLoading(false);
                    if (result.status !== 200)
                        showMessage("Aviso", result.message, 'error', null);
                    else {
                        showMessage("Aviso", "Requerimento cancelado com sucesso!", 'success', function () {
                            window.location.reload();
                        });
                    }
                });
            }
        })
    }

    const [esqueceuSenha, set_esqueceuSenha] = useState(false);
    const [recuperarRequerimento, set_recuperarRequerimento] = useState(false);

    const [modal, setModal] = useState(false);
    const openModal = (item) => {
        set_itemMeuCadastro(item);
        set_esqueceuSenha(false);
        setModal(!modal);
    }

    const loadProtocolo = () => {
        let paramentros = { protocolo_Id: null, senha: null }
        let _autenticacaoUsuario = JSON.parse(localStorage.getItem("AutenticacaoUsuario"));

        if (_autenticacaoUsuario) {
            paramentros.protocolo_Id = _autenticacaoUsuario.protocolo_Id;
            paramentros.senha = _autenticacaoUsuario.senha;
        } else {
            let data = getValues();
            paramentros.senha = data.senhaModal;
            paramentros.protocolo_Id = itemMeuCadastro.protocolo_Id;
        }

        set_protocolo(null);
        setshowLoading(true);
        api_GET('protocolo/ByDocumentoSenha/' + paramentros.protocolo_Id + "/" + paramentros.senha).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setModal(false);
                if (result.data.status == "Pendente") {
                    if (result.data.requerimento.filter(f => f.status == "Em Andamento" || f.status == "Pendente" || f.status == "Divergente").length == 0) {
                        showMessage("Atenção", "Não foi localizado o requerimento do seu protocolo!", 'warning', null);
                        return;
                    }
                    else {
                        setTimeout(function () {
                            let _requerimento = result.data.requerimento.filter(f => f.status == "Em Andamento" || f.status == "Pendente" || f.status == "Divergente")[0];
                            history.push({ pathname: "/auth/ConsultaRequerimento", state: { protocolo: result.data, requerimento: _requerimento } });
                        }, 500)
                    }
                }
                else {
                    localStorage.setItem("AutenticacaoUsuario", JSON.stringify({
                        protocolo_Id: paramentros.protocolo_Id,
                        senha: paramentros.senha,
                        dataAcesso: new Date().getTime()
                    }));
                    set_protocolo(result.data);
                }
            }
        });
    }

    const confirmaSenha = () => {
        let data = getValues();

        if (!data.senhaModal) {
            showMessage("Atenção", "Informe a senha para acessar MEU CADASTRO!", 'warning', null);
            return;
        }

        loadProtocolo();
    }

    const recuperarSenha = () => {
        clearErrors();
        let data = getValues();

        if (data.novoEmail.length == 0 || data.codigoCadastro.length == 0) {
            if (data.novoEmail.length == 0)
                setError("novoEmail", { type: "focus" }, { shouldFocus: false });
            if (data.codigoCadastro.length == 0)
                setError("codigoCadastro", { type: "focus" }, { shouldFocus: false });
            return;
        }

        let new_password = Math.random().toString(36).slice(-8);
        let json_post = {
            protocolo_Id: itemMeuCadastro.protocolo_Id,
            novaSenha: new_password,
            email: data.novoEmail,
            codigoCadastro: data.codigoCadastro
        }

        setshowLoading(true);
        api_POST(`protocolo/PostAtualizarSenha`, json_post).then(result => {
            if (result.status !== 200) {
                setshowLoading(false);
                showMessage("Atenção", result.message, 'error', null);
            }
            else {
                setshowLoading(false);
                showMessage("Atenção", "Uma nova senha foi enviada para seu email.", 'success', null);
            }
        });
    }

    const handleRecuperarRequerimento = (item) => {
        openModal(item);
        set_recuperarRequerimento(true);
    }

    const confirmarRecuperarRequerimento = () => {
        clearErrors();
        let data = getValues();

        if (data.novoEmail.length == 0) {
            if (data.novoEmail.length == 0)
                setError("novoEmail", { type: "focus" }, { shouldFocus: false });
            return;
        }

        let json_post = {
            protocolo_Id: itemMeuCadastro.protocolo_Id,
            email: data.novoEmail
        }

        setshowLoading(true);
        api_POST(`protocolo/PostRecuperarRequerimento`, json_post).then(result => {
            if (result.status !== 200) {
                setshowLoading(false);
                showMessage("Atenção", result.message, 'error', null);
            }
            else {
                setshowLoading(false);
                showMessage("Atenção", "Enviado o Requerimento para E-Mail informado.", 'success', null);
            }
        });
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <img src={require("assets/img/loading.gif")}></img>
                    </div>
                </div>
            }
            <div className="content" style={{ marginTop: "50px" }}>
                {protocolo == null &&
                    <Card className="card-stats">
                        <CardBody>
                            <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                                {!meuCadastro &&
                                    <h2 className="titulo-solicitacao">Meu Cadastro {localStorage.getItem("roc-identificacao")}</h2>
                                }
                                {meuCadastro &&
                                    <h2 className="titulo-solicitacao">Bem-vindo</h2>
                                }
                                {meuCadastro && meuCadastro.segmentos.filter(f => f.statusProtocolo == "Ativo").length > 0 && setup && setup.tipoCertificadoTransportador == "Unificado" &&
                                    <div className="row">
                                        <div className="col-12 col-lg-12 col-sm-12 text-center">
                                            <h6>Clique no QRCode abaixo para extrair seu Certificado</h6>
                                            <i style={{ cursor: "pointer" }} onClick={() => window.open("/empty/CertificadoTransportadorUnificado?protocolo=" + meuCadastro.segmentos[0].numeroProtocolo, "_blank")} className="fas fa-qrcode fa-2x"></i>
                                        </div>
                                    </div>
                                }
                                <div className="formPrincipal">
                                    <Row className={"justify-content-md-center"}>
                                        {!meuCadastro &&
                                            <div style={{ width: "100%" }}>
                                                <Row className={"justify-content-md-center"}>
                                                    <Col md="6" lg="3">
                                                        <FormGroup>
                                                            <b><label>CNPJ/CPF</label></b>
                                                            <Input type="text" maxLength="14" name="cpf_cnpj" innerRef={register({ required: true })} autoComplete="off" />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4" lg="2">
                                                        <Button color="info" className="btn-mobile" type="button" onClick={() => { handleClickConsultar(); }} style={{ width: "100%" }}><i class="fas fa-search"></i> Consultar</Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                    </Row>
                                    {meuCadastro != null && meuCadastro.segmentos.length > 0 &&
                                        <Row className={"justify-content-md-center"}>
                                            {meuCadastro.segmentos.map((item, key) => {
                                                return handleCard(item, key);
                                            })}
                                        </Row>
                                    }
                                </div>
                            </Container>
                        </CardBody>
                    </Card>
                }

                <Modal isOpen={modal} centered toggle={() => setModal(false)}>
                    <ModalHeader
                        close={<button className="close" onClick={() => setModal(false)}>&times;</button>}
                        className="md-hd"><i className={itemMeuCadastro && itemMeuCadastro.classeIcone}></i> Acesso de {itemMeuCadastro && itemMeuCadastro.nomeResponsavel}
                        <label className="ml-2">{itemMeuCadastro && itemMeuCadastro.categoria_Descricao}</label>
                    </ModalHeader>
                    <ModalBody className="md-bd">
                        {!esqueceuSenha && !recuperarRequerimento &&
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <b><label>Senha</label></b>
                                        <Input type="password" name="senhaModal" innerRef={register({ required: true })} defaultValue="" />
                                        <a href="#" onClick={() => set_esqueceuSenha(true)}>Esqueci a Senha</a>
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                        {esqueceuSenha &&
                            <Row>
                                <Col md="12">
                                    <label>Informe os dados abaixo para recuperar a senha de acesso para o cadastro de {itemMeuCadastro.nomeResponsavel}</label>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <b><label>E-mail</label></b>
                                        <Input type="text" name="novoEmail" innerRef={register({ required: true })} autoComplete="off" />
                                        {errors.novoEmail && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <b><label>Código Cadastro - {localStorage.getItem("roc-identificacao")}</label></b>
                                        <Input type="text" name="codigoCadastro" innerRef={register({ required: true })} autoComplete="off" />
                                        {errors.codigoCadastro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <span className="text-danger">
                                    ATENÇÃO!
                                    Caso você seja Grande Gerador de Resíduo Comum (RGG), o seu Código Cadastro - SP Regula se encontra abaixo do QR-Code escaneado durante as coletas.
                                    Insira o código sem as letras e com a barra.
                                    Exemplo: 1234567/2024
                                    Para os demais resíduos como RCC e RSS favor entrar em contato com a SP-REGULA
                                    </span>
                                </Col>
                            </Row>
                        }
                        {recuperarRequerimento &&
                            <Row>
                                <Col md="12">
                                    <label>Informe E-Mail para recuperar o requerimento do cadastro de {itemMeuCadastro.nomeResponsavel}</label>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <b><label>E-mail</label></b>
                                        <Input type="text" name="novoEmail" innerRef={register({ required: true })} autoComplete="off" />
                                        {errors.novoEmail && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                    </ModalBody>
                    <ModalFooter className="md-ft">
                        <Row>
                            <Col md="12">
                                <Button color="secondary" className="btn-mobile" onClick={() => setModal(false)}>Cancelar</Button>
                                {!esqueceuSenha && !recuperarRequerimento &&
                                    <Button color="success" className="btn-mobile" type="submit" onClick={() => confirmaSenha()}><i className="fas fa-check"></i>  Confirmar</Button>
                                }
                                {esqueceuSenha && !recuperarRequerimento &&
                                    <Button color="success" className="btn-mobile" type="submit" onClick={() => recuperarSenha()}><i className="fas fa-check"></i>  Confirmar</Button>
                                }
                                {!esqueceuSenha && recuperarRequerimento &&
                                    <Button color="success" className="btn-mobile" type="submit" onClick={() => confirmarRecuperarRequerimento()}><i className="fas fa-check"></i>  Confirmar</Button>
                                }
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>

                {protocolo != null && protocolo.protocoloTransportador != null && protocolo.protocoloTransportador.length > 0 && protocolo.status !== "Pendente" &&
                    <FichaTransportador
                        item={protocolo}
                        history={history}
                        showAcoesGestor={false}
                    />
                }
                {protocolo != null && protocolo.protocoloGerador != null && protocolo.protocoloGerador.length > 0 && protocolo.status !== "Pendente" &&
                    <FichaGerador
                        item={protocolo}
                        history={history}
                        showAcoesGestor={false}
                    />
                }
                {protocolo != null && protocolo.protocoloDestino != null && protocolo.protocoloDestino.length > 0 && protocolo.status !== "Pendente" &&
                    <FichaDestino
                        item={protocolo}
                        history={history}
                        showAcoesGestor={false}
                    />
                }
            </div>
        </>
    );
}
